import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import { reactular } from '@vendhq/reactular'
import React, { FC } from 'react'
import { vn } from 'vend-number'
import { T, TFunction, useT } from '@transifex/react'
import {
  LSPAY_PAY_LINK_MAX_AMOUNT,
  LSPAY_PAY_LINK_MIN_AMOUNT,
} from '@vend/business-components'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'

interface Props {
  amount: number
  close: (val: Promise<boolean>) => void
}

const getHeaderContent = (
  amount: number,
  vdCurrencyFilter: (value: number) => string,
  t: TFunction
): string => {
  const minAmountFormatted = vdCurrencyFilter(LSPAY_PAY_LINK_MIN_AMOUNT)
  const maxAmountFormatted = vdCurrencyFilter(LSPAY_PAY_LINK_MAX_AMOUNT)
  return vn(amount).gt(LSPAY_PAY_LINK_MAX_AMOUNT)
    ? t(
        'Unable to take online payments for on account sales greater than {maxAmountFormatted}',
        {
          _context: 'Payment link limit modal header',
          maxAmountFormatted,
        }
      )
    : t(
        'Unable to take online payments for on account sales less than {minAmountFormatted}',
        {
          _context: 'Payment link limit modal header',
          minAmountFormatted,
        }
      )
}
export const PayLinkLimitModal: FC<Props> = ({ amount, close }) => {
  const vdCurrencyFilter = useVdCurrencyFilter()
  const t = useT()
  const onCancel = () => {
    close(Promise.resolve(false))
  }

  const onContinue = () => {
    close(Promise.resolve(true))
  }

  return (
    <Modal size="small" dismissable onClose={onCancel}>
      <ModalHeader>{getHeaderContent(amount, vdCurrencyFilter, t)}</ModalHeader>
      <ModalContent>
        <p className="vd-p">
          <T
            _str="A pay link will not be included in the email receipt for this on
            account sale. You can continue the sale or cancel to return to the pay
            screen."
            _context="Payment link limit modal description"
          />
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button variant="supplementary" onClick={onCancel}>
            <T _str="Cancel" _context="Button" />
          </Button>
          <Button variant="go" onClick={onContinue} autoFocus>
            <T _str="Continue" _context="Button" />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}

export const PayLinkLimitModalComponent = reactular(
  PayLinkLimitModal,
  ['amount', 'close'],
  'reactWrapper'
)
